import { FC, useRef } from 'react';

import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { GridColDef } from '@material-ui/data-grid';
import AddIcon from '@material-ui/icons/Add';
import FilterDrawer from 'src/components/FilterDrawer';
import { FilterDrawerRef } from 'src/components/FilterDrawer/interfaces';
import LinkButton from 'src/components/LinkButton';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import usePagination from 'src/hooks/usePagination';
import INotice from 'src/interfaces/models/INotice';
import NoticeFilterSchema from 'src/validators/Notice/filter.schema';

import Filters from './Filters';
import { Container } from './styles';

const List: FC = () => {
  const filterRef = useRef<FilterDrawerRef>(null);
  const {
    handlePageChange,
    handlePageSizeChange,
    data,
    loading,
    info,
    loadData,
  } = usePagination<INotice>('admin/notices');

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'description', headerName: 'Descrição', flex: 1 },
    {
      field: 'show_ifbolsas',
      headerName: 'IFBOLSAS',
      width: 130,
      align: 'center',
      headerAlign: 'center',
      valueFormatter({ value }) {
        return value ? 'Sim' : 'Não';
      },
    },
    {
      field: 'show_ifepaf',
      headerName: 'IFEPAF',
      width: 130,
      align: 'center',
      headerAlign: 'center',
      valueFormatter({ value }) {
        return value ? 'Sim' : 'Não';
      },
    },
    {
      field: 'subsites',
      headerName: 'Nº Subsites',
      sortable: false,
      width: 150,
      align: 'center',
      valueFormatter({ row }) {
        return row.subsites?.length || 0;
      },
    },
    {
      field: '',
      disableColumnMenu: true,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell({ id }) {
        return (
          <TableActions
            resource="Notícia"
            editLink={`/noticias/${id}`}
            deleteApiUrl={`/admin/notices/${id}`}
            descriptionPrefix={`A notícia ${id}`}
            onFinish={loadData}
          />
        );
      },
    },
  ];

  return (
    <Container>
      <FilterDrawer
        ref={filterRef}
        columns={columns.filter((column) => !column.hide && column.field)}
        yupSchema={NoticeFilterSchema}
      >
        <Filters formRef={filterRef.current?.getFormRef()} />
      </FilterDrawer>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h5">Notícias</Typography>

            <LinkButton
              to="/noticias/novo"
              startIcon={<AddIcon />}
              color="primary"
              variant="contained"
              size="small"
            >
              Nova
            </LinkButton>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Table
                autoHeight
                rows={data}
                page={info.current_page - 1}
                pageSize={info.per_page}
                rowCount={info.total}
                columns={columns}
                loading={loading}
                pagination
                paginationMode="server"
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                onFilterClick={filterRef.current?.open}
                canSearch
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default List;
